import React from "react";
import { useTranslation } from "react-i18next";
import PageWrapper from "../pageWrapper";

//CSS
import "./employeePage.css";
import "../0PageStyles.css";

//Components
import EmployeeView from "../../Components/Employee Components/employeeView";

//Functions and hooks

export default function EmployeePage() {
  const { t } = useTranslation();

  const tutorialSteps = [
    {
      target: null,
      title: t("Your employees", { ns: "tutorial" }),
      message: t(
        "This is your Employees page - everyone with access to your company's account lives here, each with a role that controls what they can do.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".btn-container.employee-view .btn-positive:first-child",
      title: t("Add employee", { ns: "tutorial" }),
      message: t(
        "Invite a new employee by entering their email and choosing which role to give them.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".btn-container.employee-view .btn-positive:last-child",
      title: t("Send announcement", { ns: "tutorial" }),
      message: t(
        "Send a message to some or all of your employees at once - it'll show up in their Messages page.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".search-bar-container",
      title: t("Search", { ns: "tutorial" }),
      message: t("Search for an employee by name or ID.", { ns: "tutorial" }),
    },
    {
      target: ".sortAndFilterBar",
      title: t("Sort and filter", { ns: "tutorial" }),
      message: t(
        "Sort the list by name or ID, and use Filters to narrow employees down by role or warehouse access.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".item-card-container .employee-card:first-of-type",
      title: t("Employee cards", { ns: "tutorial" }),
      message: t(
        "Each card is one employee, showing their name, role, and warehouse access. Click a card to see or change their details.",
        { ns: "tutorial" }
      ),
    },
  ];

  return (
    <PageWrapper tutorialId="employees" tutorialSteps={tutorialSteps}>
      <div className="page-content h-100">
        <div className="view-page-container h-100">
          <EmployeeView />
        </div>
      </div>
    </PageWrapper>
  );
}
